import React from 'react'
import PropTypes from 'prop-types'
import Paginator from '../Paginator/Paginator'

const Pagination = ({ paging ,selectNextPage, selectPrevPage, className }) => {
    const { current, total } = paging

    return (
        <Paginator
            className={className}
            total={total}
            current={current + 1}
            onNextClick={selectNextPage}
            onPrevClick={selectPrevPage}
        />
    )
}

Pagination.propTypes = {
    paging: PropTypes.shape({
        current: PropTypes.number.isRequired,
        total: PropTypes.number.isRequired,
    }).isRequired,
    selectPrevPage: PropTypes.func.isRequired,
    selectNextPage: PropTypes.func.isRequired,
    className: PropTypes.string,
}

export default Pagination



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/components/Pagination/Pagination.jsx